// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"17e0f174","419":"b12293ae","490":"236a19c7","638":"56587d32","670":"9544ce57"}[chunkId] + ".chunk.js";
};